export enum EntityActionModalBlock {
  Root = 'EntityActionModal',
}
